import dayjs from 'dayjs';

export const getColorByRelativeDate = ({ date }: { date: Date }): string => {
  if (!date) {
    return 'grey';
  }

  if (dayjs(date).isAfter(dayjs().subtract(24, 'hour'))) {
    return 'blue';
  }

  if (dayjs(date).isAfter(dayjs().subtract(7, 'day'))) {
    return 'orange';
  }

  if (dayjs(date).isAfter(dayjs().subtract(14, 'day'))) {
    return 'red';
  }

  if (dayjs(date).isAfter(dayjs().subtract(30, 'day'))) {
    return 'purple';
  }

  if (dayjs(date).isAfter(dayjs().subtract(90, 'day'))) {
    return 'gold';
  }

  if (dayjs(date).isAfter(dayjs().subtract(365, 'day'))) {
    return 'lime';
  }

  return 'grey';
};
